export const ORGANIZATION_ENDPOINTS = {
  LIST: "/organization",
  CREATE: "/organization",
  UPDATE: (unitId) => `/organization/${unitId}`,
  DELETE: (unitId) => `/organization/${unitId}`,
  LOOKUPS: "/organization/lookups",
};
